import { normalizeTimerTheme } from '@/constants/timerThemes';

const SINGLE_CUSTOM_LAYOUTS = {
  custom: {
    vars: {
      '--custom-slot-radius': '14px',
      '--custom-slot-padding': '10px',
      '--custom-country-font-size': 'clamp(1.8rem, 3.2vw, 3.4rem)',
      '--custom-phase-font-size': 'clamp(1.6rem, 2.7vw, 2.8rem)',
      '--custom-name-font-size': 'clamp(3.3rem, 4.4vw, 4.5rem)',
      '--custom-name-gap': '0.18em',
      '--custom-power-font-size': 'clamp(1.8rem, 3vw, 3rem)',
      '--custom-power-radius': '18px',
      '--custom-main-timer-font-size': 'clamp(6rem, 21vw, 18rem)',
      '--custom-status-gap': 'clamp(8px, 1vw, 14px)',
      '--custom-status-pause-width': 'clamp(10px, 0.9vw, 16px)',
      '--custom-status-pause-height': 'clamp(44px, 5.2vw, 72px)',
      '--custom-status-play-top': 'clamp(22px, 2vw, 30px)',
      '--custom-status-play-bottom': 'clamp(22px, 2vw, 30px)',
      '--custom-status-play-left': 'clamp(34px, 3vw, 48px)',
      '--custom-status-play-offset': 'clamp(6px, 0.5vw, 10px)',
      '--custom-status-stop-size': 'clamp(40px, 3.2vw, 58px)',
    },
    base: {
      flag: {
        right: '11%',
        top: '32%',
        width: '12%',
        height: '15%',
      },
      name: {
        left: '24%',
        top: '26%',
        width: '30%',
        height: '15%',
        justifyContent: 'flex-start',
        paddingInline: '18px',
        overflow: 'hidden',
      },
      phase: {
        right: '23%',
        top: '27%',
        width: '15%',
        height: '14%',
        justifyContent: 'flex-start',
        paddingInline: '18px',
      },
      status: {
        right: '11%',
        top: '56%',
        width: '14%',
        height: '15%',
      },
      power: {
        left: '14%',
        top: '34%',
        width: '8%',
        height: '8%',
      },
      timer: {
        left: '18%',
        top: '43%',
        width: '64%',
        height: '33%',
        overflow: 'hidden',
      },
    },
    breakpoints: {
      3842: {
        vars: {
        '--custom-slot-radius': '14px',
        '--custom-slot-padding': '10px',
        '--custom-country-font-size': 'clamp(1.8rem, 3.2vw, 8rem)',
        '--custom-phase-font-size': 'clamp(1.6rem, 2.7vw, 8rem)',
        '--custom-name-font-size': 'clamp(3.3rem, 4.4vw, 6rem)',
        '--custom-name-gap': '0.18em',
        '--custom-power-font-size': 'clamp(1.8rem, 3vw, 8rem)',
        '--custom-power-radius': '18px',
        '--custom-main-timer-font-size': 'clamp(6rem, 21vw, 46rem)',
        '--custom-status-gap': 'clamp(8px, 1vw, 14px)',
        '--custom-status-pause-width': 'clamp(10px, 0.9vw, 26px)',
        '--custom-status-pause-height': 'clamp(44px, 5.2vw, 80px)',
        '--custom-status-play-top': 'clamp(22px, 2vw, 30px)',
        '--custom-status-play-bottom': 'clamp(22px, 2vw, 30px)',
        '--custom-status-play-left': 'clamp(34px, 3vw, 48px)',
        '--custom-status-play-offset': 'clamp(6px, 0.5vw, 10px)',
        '--custom-status-stop-size': 'clamp(40px, 3.2vw, 70px)',
        },
        flag: {
          right: '14%',
            top: '36%',
            width: '8%',
            height: '8%',
        },
        name: {
          left: '25%',
          width: '27%',
          top: '27%',
            height: '14%',
        },
        phase: {
          right: '24%',
          width: '22%',
            top: '27%',
            height: '14%',
        },
        status: {
          right: '14%',
            top: '59%',
            width: '8%',
            height: '8%',
        },
        power: {
          left: '15%',
            top: '34%',
            width: '8%',
            height: '8%',
        },
        timer: {
          left: '24%',
            top: '43%',
            width: '53%',
            height: '31%',
        },
      },
      1922: {
        vars: {
        '--custom-slot-radius': '14px',
        '--custom-slot-padding': '10px',
        '--custom-country-font-size': 'clamp(1.8rem, 3.2vw, 8rem)',
        '--custom-phase-font-size': 'clamp(1.6rem, 2.7vw, 8rem)',
        '--custom-name-font-size': 'clamp(2.3rem, 3.2vw, 4rem)',
        '--custom-name-gap': '0.18em',
        '--custom-power-font-size': 'clamp(1.8rem, 3vw, 8rem)',
        '--custom-power-radius': '18px',
        '--custom-main-timer-font-size': 'clamp(6rem, 19vw, 26rem)',
        '--custom-status-gap': 'clamp(8px, 1vw, 14px)',
        '--custom-status-pause-width': 'clamp(10px, 0.9vw, 26px)',
        '--custom-status-pause-height': 'clamp(44px, 5.2vw, 80px)',
        '--custom-status-play-top': 'clamp(22px, 2vw, 30px)',
        '--custom-status-play-bottom': 'clamp(22px, 2vw, 30px)',
        '--custom-status-play-left': 'clamp(34px, 3vw, 48px)',
        '--custom-status-play-offset': 'clamp(6px, 0.5vw, 10px)',
        '--custom-status-stop-size': 'clamp(40px, 3.2vw, 70px)',
        },
        flag: {
          right: '14%',
            top: '36%',
            width: '8%',
            height: '8%',
        },
        name: {
          left: '25%',
          width: '27%',
          top: '27%',
            height: '14%',
        },
        phase: {
          right: '24%',
          width: '22%',
            top: '27%',
            height: '14%',
        },
        status: {
          right: '14%',
            top: '59%',
            width: '8%',
            height: '8%',
        },
        power: {
          left: '15%',
            top: '34%',
            width: '8%',
            height: '8%',
        },
        timer: {
          left: '24%',
            top: '43%',
            width: '53%',
            height: '31%',
        },
      },
      880: {
        vars: {
        '--custom-slot-radius': '14px',
        '--custom-slot-padding': '10px',
        '--custom-country-font-size': 'clamp(1.8rem, 3.2vw, 8rem)',
        '--custom-phase-font-size': 'clamp(1.6rem, 2.7vw, 8rem)',
        '--custom-name-font-size': 'clamp(2.3rem, 3.2vw, 4rem)',
        '--custom-name-gap': '0.18em',
        '--custom-power-font-size': 'clamp(1.8rem, 3vw, 8rem)',
        '--custom-power-radius': '18px',
        '--custom-main-timer-font-size': 'clamp(6rem, 17vw, 26rem)',
        '--custom-status-gap': 'clamp(8px, 1vw, 14px)',
        '--custom-status-pause-width': 'clamp(10px, 0.9vw, 26px)',
        '--custom-status-pause-height': 'clamp(44px, 5.2vw, 80px)',
        '--custom-status-play-top': 'clamp(22px, 2vw, 30px)',
        '--custom-status-play-bottom': 'clamp(22px, 2vw, 30px)',
        '--custom-status-play-left': 'clamp(34px, 3vw, 48px)',
        '--custom-status-play-offset': 'clamp(6px, 0.5vw, 10px)',
        '--custom-status-stop-size': 'clamp(40px, 3.2vw, 70px)',
        },
        flag: {
          right: '14%',
            top: '36%',
            width: '8%',
            height: '8%',
        },
        name: {
          top: '24%',
        },
        phase: {
            top: '24%',
        },
        status: {
          right: '14%',
            top: '59%',
            width: '8%',
            height: '8%',
        },
        power: {
          left: '15%',
            top: '34%',
            width: '8%',
            height: '8%',
        },
        timer: {
            height: '33%',
        },
      },
    },
  },
  custom_2: {
    vars: {
      '--custom-slot-radius': '14px',
      '--custom-slot-padding': '10px',
      '--custom-phase-font-size': 'clamp(1.6rem, 2.7vw, 2.8rem)',
      '--custom-name-font-size': 'clamp(3.3rem, 4.4vw, 4.5rem)',
      '--custom-name-gap': '0.18em',
      '--custom-main-timer-font-size': 'clamp(6rem, 21vw, 18rem)',
    },
    base: {
      name: {
        left: '24%',
        top: '26%',
        width: '30%',
        height: '15%',
        justifyContent: 'flex-start',
        paddingInline: '18px',
        overflow: 'hidden',
      },
      phase: {
        right: '23%',
        top: '27%',
        width: '15%',
        height: '14%',
        justifyContent: 'flex-start',
        paddingInline: '18px',
      },
      timer: {
        left: '18%',
        top: '43%',
        width: '64%',
        height: '33%',
        overflow: 'hidden',
      },
    },
    breakpoints: {
      3842: {
         vars: {
        '--custom-main-timer-font-size': 'clamp(6rem, 21vw, 48rem)',
        '--custom-phase-font-size': 'clamp(4rem, 6vw, 7rem)',
        '--custom-name-font-size': 'clamp(4rem, 6vw, 7rem)',
        },
        name: {
           left: '22%',
            top: '24%',
            width: '30%',
            height: '16%',
        },
        phase: {
            right: '20%',
            top: '24%',
            width: '26%',
            height: '16%',
        },
        timer: {
            left: '21%',
            width: '59%',
        },
      },
      1922: {
         vars: {
        '--custom-main-timer-font-size': 'clamp(6rem, 21vw, 48rem)',
        '--custom-phase-font-size': 'clamp(1.8rem, 4vw, 5.6rem)',
        '--custom-name-font-size': 'clamp(1.6rem, 3.1vw, 4.7rem)',
        },
        name: {
           left: '22%',
            top: '24%',
            width: '30%',
            height: '16%',
        },
        phase: {
            right: '20%',
            top: '24%',
            width: '26%',
            height: '16%',
        },
        timer: {
            left: '21%',
            width: '59%',
        },
      },
      880: {
         vars: {
        '--custom-main-timer-font-size': 'clamp(6rem, 21vw, 50rem)',
        '--custom-phase-font-size': 'clamp(1.8rem, 4vw, 5.6rem)',
        '--custom-name-font-size': 'clamp(1.6rem, 3.1vw, 4.7rem)',
        },
        name: {
            top: '20%',
        },
        phase: {
            top: '20%',
        },
        timer: {
            left: '21%',
            height: '40%',
            width: '59%',
        },
      },
    },
  },
};

const VS_CUSTOM_LAYOUTS = {
  custom: {
    vars: {
      '--vs-name-font-size': 'clamp(3.3rem, 4.4vw, 4.5rem)',
      '--vs-country-font-size': 'clamp(1.8rem, 3.2vw, 3.4rem)',
      '--vs-power-font-size': 'clamp(1.8rem, 3vw, 3rem)',
      '--vs-power-radius': '18px',
      '--vs-main-timer-font-size': 'clamp(7rem, 22vw, 26rem)',
      '--vs-secondary-timer-font-size': 'clamp(4.2rem, 8.3vw, 11rem)',
      '--vs-status-gap': 'clamp(8px, 1vw, 14px)',
      '--vs-status-pause-width': 'clamp(10px, 0.9vw, 16px)',
      '--vs-status-pause-height': 'clamp(44px, 5.2vw, 72px)',
      '--vs-status-play-top': 'clamp(22px, 2vw, 30px)',
      '--vs-status-play-bottom': 'clamp(22px, 2vw, 30px)',
      '--vs-status-play-left': 'clamp(34px, 3vw, 48px)',
      '--vs-status-play-offset': 'clamp(6px, 0.5vw, 10px)',
      '--vs-status-stop-size': 'clamp(40px, 3.2vw, 58px)',
    },
    base: {
      athleteName: {
        left: '24%',
        top: '26%',
        width: '27%',
        height: '15%',
        justifyContent: 'flex-start',
        paddingInline: '0px',
        overflow: 'hidden',
      },
      athleteCode: {
        right: '12%',
        top: '32%',
        width: '12%',
        height: '15%',
      },
      status: {
        right: '11%',
        top: '56%',
        width: '14%',
        height: '15%',
      },
      power: {
        left: '15%',
        top: '34%',
        width: '8%',
        height: '8%',
      },
      mainTimer: {
        left: '24%',
        top: '43%',
        width: '53%',
        height: '32%',
      },
      secondaryTimer: {
        left: '52%',
        top: '27%',
        width: '24%',
        height: '14%',
      },
    },
    breakpoints: {
        3842: {
        vars: {
        '--vs-name-font-size': 'clamp(4rem, 2.6vw, 11rem)',
        '--vs-country-font-size': 'clamp(1.8rem, 3.2vw, 12rem)',
        '--vs-power-font-size': 'clamp(3.4rem, 7vw, 8rem)',
        '--vs-power-radius': '18px',
        '--vs-main-timer-font-size': 'clamp(7rem, 19vw, 46rem)',
        '--vs-secondary-timer-font-size': 'clamp(7rem, 8vw, 21rem)',
        '--vs-status-gap': 'clamp(8px, 1vw, 14px)',
        '--vs-status-pause-width': 'clamp(10px, 0.9vw, 16px)',
        '--vs-status-pause-height': 'clamp(44px, 5.2vw, 72px)',
        '--vs-status-play-top': 'clamp(22px, 2vw, 30px)',
        '--vs-status-play-bottom': 'clamp(22px, 2vw, 30px)',
        '--vs-status-play-left': 'clamp(34px, 3vw, 48px)',
        '--vs-status-play-offset': 'clamp(6px, 0.5vw, 10px)',
        '--vs-status-stop-size': 'clamp(40px, 3.2vw, 120px)',
        },
        athleteName: {
           left: '24%',
            top: '26%',
            width: '27%',
            height: '15%',
        },
        athleteCode: {
            right: '12%',
            top: '32%',
            width: '12%',
            height: '15%',
        },
        status: {
            right: '14%',
            top: '58%',
            width: '8%',
            height: '8%',
        },
        power: {
            left: '15%',
            top: '34%',
            width: '8%',
            height: '8%',
        },
        mainTimer: {
          width: '53%',
        },
        
      },
        1922: {
        vars: {
        '--vs-name-font-size': 'clamp(1rem, 2.6vw, 4rem)',
        '--vs-country-font-size': 'clamp(1.8rem, 3.2vw, 3.4rem)',
        '--vs-power-font-size': 'clamp(1rem, 2.4vw, 3rem)',
        '--vs-power-radius': '18px',
        '--vs-main-timer-font-size': 'clamp(7rem, 19vw, 29rem)',
        '--vs-secondary-timer-font-size': 'clamp(3rem, 6.2vw, 11rem)',
        '--vs-status-gap': 'clamp(8px, 1vw, 14px)',
        '--vs-status-pause-width': 'clamp(10px, 0.9vw, 16px)',
        '--vs-status-pause-height': 'clamp(44px, 5.2vw, 72px)',
        '--vs-status-play-top': 'clamp(22px, 2vw, 30px)',
        '--vs-status-play-bottom': 'clamp(22px, 2vw, 30px)',
        '--vs-status-play-left': 'clamp(34px, 3vw, 48px)',
        '--vs-status-play-offset': 'clamp(6px, 0.5vw, 10px)',
        '--vs-status-stop-size': 'clamp(30px, 3.2vw, 58px)',
        },
        athleteName: {
           left: '24%',
            top: '26%',
            width: '27%',
            height: '15%',
        },
        athleteCode: {
            right: '12%',
            top: '32%',
            width: '12%',
            height: '15%',
        },
        status: {
            right: '14%',
            top: '58%',
            width: '8%',
            height: '8%',
        },
        power: {
            left: '15%',
            top: '34%',
            width: '8%',
            height: '8%',
        },
        mainTimer: {
          width: '53%',
        },
        
      },
        880: {
        vars: {
        '--vs-name-font-size': 'clamp(1rem, 2.6vw, 4rem)',
        '--vs-country-font-size': 'clamp(1.8rem, 3.2vw, 3.4rem)',
        '--vs-power-font-size': 'clamp(1rem, 2.4vw, 3rem)',
        '--vs-power-radius': '18px',
        '--vs-main-timer-font-size': 'clamp(7rem, 10vw, 10rem)',
        '--vs-secondary-timer-font-size': 'clamp(3rem, 6.2vw, 11rem)',
        '--vs-status-gap': 'clamp(8px, 1vw, 14px)',
        '--vs-status-pause-width': 'clamp(10px, 0.9vw, 16px)',
        '--vs-status-pause-height': 'clamp(44px, 5.2vw, 72px)',
        '--vs-status-play-top': 'clamp(22px, 2vw, 30px)',
        '--vs-status-play-bottom': 'clamp(22px, 2vw, 30px)',
        '--vs-status-play-left': 'clamp(34px, 3vw, 48px)',
        '--vs-status-play-offset': 'clamp(6px, 0.5vw, 10px)',
        '--vs-status-stop-size': 'clamp(30px, 3.2vw, 58px)',
        },
        athleteName: {
           left: '24%',
            top: '26%',
            width: '27%',
            height: '15%',
        },
        athleteCode: {
            right: '12%',
            top: '32%',
            width: '12%',
            height: '15%',
        },
        status: {
            right: '14%',
            top: '58%',
            width: '8%',
            height: '8%',
        },
        power: {
            left: '15%',
            top: '34%',
            width: '8%',
            height: '8%',
        },
        mainTimer: {
          left: '24%',
          width: '50%',
        },
        secondaryTimer: {
            left: '52%',
            top: '27%',
            width: '24%',
            height: '14%',
        },
      },
     
    },
  },
  custom_2: {
    vars: {
      '--vs-name-font-size': 'clamp(3.3rem, 4.4vw, 4.5rem)',
      '--vs-country-font-size': 'clamp(1.8rem, 3.2vw, 3.4rem)',
      '--vs-power-font-size': 'clamp(1.8rem, 3vw, 3rem)',
      '--vs-power-radius': '18px',
      '--vs-main-timer-font-size': 'clamp(7rem, 22vw, 31rem)',
      '--vs-secondary-timer-font-size': 'clamp(4.2rem, 8.3vw, 11.4rem)',
      '--vs-status-gap': 'clamp(8px, 1vw, 14px)',
      '--vs-status-pause-width': 'clamp(10px, 0.9vw, 16px)',
      '--vs-status-pause-height': 'clamp(44px, 5.2vw, 72px)',
      '--vs-status-play-top': 'clamp(22px, 2vw, 30px)',
      '--vs-status-play-bottom': 'clamp(22px, 2vw, 30px)',
      '--vs-status-play-left': 'clamp(34px, 3vw, 48px)',
      '--vs-status-play-offset': 'clamp(6px, 0.5vw, 10px)',
      '--vs-status-stop-size': 'clamp(40px, 3.2vw, 58px)',
    },
    base: {
      athleteName: {
        left: '17%',
        top: '26%',
        width: '34%',
        height: '15%',
        justifyContent: 'flex-start',
        paddingInline: '0px',
        overflow: 'hidden',
      },
      athleteCode: {
        right: '12%',
        top: '32%',
        width: '12%',
        height: '15%',
      },
      status: {
        right: '11%',
        top: '56%',
        width: '14%',
        height: '15%',
      },
      power: {
        left: '15%',
        top: '34%',
        width: '8%',
        height: '8%',
      },
      mainTimer: {
        left: '17%',
        top: '45%',
        width: '67%',
        height: '33%',
      },
      secondaryTimer: {
        left: '52%',
        top: '27%',
        width: '27%',
        height: '15%',
      },
    },
    breakpoints: {
        3842: {
        vars: {
          '--vs-name-font-size': 'clamp(1rem, 2.8vw, 8rem)',
          '--vs-country-font-size': 'clamp(0.7rem, 1.6vw, 1.1rem)',
          '--vs-power-font-size': 'clamp(1rem, 3vw, 1.6rem)',
          '--vs-main-timer-font-size': 'clamp(4.2rem, 18vw, 48rem)',
          '--vs-secondary-timer-font-size': 'clamp(1.35rem, 7vw, 16rem)',
        },
        athleteName: {
          left: '21%',
          top: '26%',
          width: '30%',
          height: '15%',
        },
        athleteCode: {
          left: '86%',
          right: 'auto',
          width: '7%',
        },
        status: {
          right: '7%',
          top: '14%',
          width: '20%',
          height: '13%',
        },
        power: {
          left: '7%',
          top: '14%',
          width: '18%',
          height: '10%',
        },
        mainTimer: {
          left: '21%',
          top: '43%',
          width: '58%',
          height: '34%',
        },
        secondaryTimer: {
          left: '52%',
          top: '27%',
          width: '23%',
          height: '14%',
        },
      },
        1922: {
        vars: {
          '--vs-name-font-size': 'clamp(1rem, 2.8vw, 8rem)',
          '--vs-country-font-size': 'clamp(0.7rem, 1.6vw, 1.1rem)',
          '--vs-power-font-size': 'clamp(1rem, 3vw, 1.6rem)',
          '--vs-main-timer-font-size': 'clamp(4.2rem, 18vw, 31rem)',
          '--vs-secondary-timer-font-size': 'clamp(1.35rem, 7vw, 8rem)',
        },
        athleteName: {
          left: '21%',
          top: '26%',
          width: '30%',
          height: '15%',
        },
        athleteCode: {
          left: '86%',
          right: 'auto',
          width: '7%',
        },
        status: {
          right: '7%',
          top: '14%',
          width: '20%',
          height: '13%',
        },
        power: {
          left: '7%',
          top: '14%',
          width: '18%',
          height: '10%',
        },
        mainTimer: {
          left: '21%',
          top: '43%',
          width: '58%',
          height: '34%',
        },
        secondaryTimer: {
          left: '52%',
          top: '27%',
          width: '23%',
          height: '14%',
        },
      },
        880: {
        vars: {
          '--vs-name-font-size': 'clamp(1rem, 2.8vw, 1.5rem)',
          '--vs-country-font-size': 'clamp(0.7rem, 1.6vw, 1.1rem)',
          '--vs-power-font-size': 'clamp(1rem, 3vw, 1.6rem)',
          '--vs-main-timer-font-size': 'clamp(4.2rem, 18vw, 10rem)',
          '--vs-secondary-timer-font-size': 'clamp(1.35rem, 7vw, 7rem)',
        },
        athleteName: {
          left: '21%',
          top: '22%',
          width: '30%',
          height: '15%',
        },
        athleteCode: {
          left: '86%',
          right: 'auto',
          width: '7%',
        },
        status: {
          right: '7%',
          top: '14%',
          width: '20%',
          height: '13%',
        },
        power: {
          left: '7%',
          top: '14%',
          width: '18%',
          height: '10%',
        },
        mainTimer: {
          left: '21%',
          top: '43%',
          width: '58%',
          height: '40%',
        },
        secondaryTimer: {
          left: '53%',
          top: '24%',
          width: '23%',
          height: '14%',
        },
      },
     
    },
  },
};

function cloneSlotStyles(slotStyles = {}) {
  return Object.entries(slotStyles).reduce((accumulator, [slotName, slotConfig]) => {
    accumulator[slotName] = { ...slotConfig };
    return accumulator;
  }, {});
}

function cloneVars(vars = {}) {
  return { ...vars };
}

function normalizeViewportDimension(value, fallback) {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue > 0 ? numericValue : fallback;
}

function getLayoutViewportProfile(viewportWidth, viewportHeight) {
  const width = normalizeViewportDimension(viewportWidth, 1920);
  const height = normalizeViewportDimension(viewportHeight, 1080);
  const aspectRatio = width / Math.max(height, 1);

  if (width >= 3000 || height >= 1800) {
    return {
      key: 'videoWall',
      width,
      height,
      aspectRatio,
      legacyBreakpoint: 3842,
    };
  }

  if (width >= 1850 && height >= 1000) {
    return {
      key: 'tvDesktopFullscreen',
      width,
      height,
      aspectRatio,
      legacyBreakpoint: 1922,
    };
  }

  if (width >= 1200 && height >= 720) {
    return {
      key: 'monitorDesktop',
      width,
      height,
      aspectRatio,
      legacyBreakpoint: 1922,
    };
  }

  if (width >= 1000 && height >= 600) {
    return {
      key: 'tabletLandscape',
      width,
      height,
      aspectRatio,
      legacyBreakpoint: 880,
    };
  }

  return {
    key: 'mobileLandscape',
    width,
    height,
    aspectRatio,
    legacyBreakpoint: 880,
  };
}

function resolvePresetBuckets(preset) {
  return preset?.buckets || null;
}

function applySlotOverrides(target, overrides = {}) {
  if (!overrides || typeof overrides !== 'object' || Array.isArray(overrides)) {
    return;
  }

  Object.entries(overrides).forEach(([slotName, slotConfig]) => {
    if (slotName === 'vars' || !slotConfig || typeof slotConfig !== 'object' || Array.isArray(slotConfig)) return;
    target[slotName] = {
      ...(target[slotName] || {}),
      ...slotConfig,
    };
  });
}

function resolvePresetBreakpoints(preset) {
  return Object.keys(preset?.breakpoints || {})
    .map((breakpoint) => Number(breakpoint))
    .filter((breakpoint) => Number.isFinite(breakpoint))
    .sort((left, right) => right - left);
}

function resolvePresetCollection(mode, theme) {
  const normalizedTheme = normalizeTimerTheme(theme);
  const source = mode === 'vs' ? VS_CUSTOM_LAYOUTS : SINGLE_CUSTOM_LAYOUTS;
  return source[normalizedTheme] || source.custom || null;
}

function resolveLegacyBreakpointKey(preset, layoutProfile) {
  const presetBreakpoints = resolvePresetBreakpoints(preset);
  if (!presetBreakpoints.length) return null;

  if (layoutProfile?.legacyBreakpoint && preset.breakpoints?.[layoutProfile.legacyBreakpoint]) {
    return layoutProfile.legacyBreakpoint;
  }

  return presetBreakpoints.find((breakpoint) => layoutProfile.width <= breakpoint) || null;
}

export function resolveCustomTimerSlotStyles(mode, theme, viewportWidth, viewportHeight) {
  const preset = resolvePresetCollection(mode, theme);
  if (!preset) return {};

  const layoutProfile = getLayoutViewportProfile(viewportWidth, viewportHeight);

  const resolved = cloneSlotStyles(preset.base);
  const bucketOverrides = resolvePresetBuckets(preset)?.[layoutProfile.key] || null;
  applySlotOverrides(resolved, bucketOverrides);

  const legacyBreakpoint = resolveLegacyBreakpointKey(preset, layoutProfile);
  if (legacyBreakpoint) {
    applySlotOverrides(resolved, preset.breakpoints?.[legacyBreakpoint] || {});
  }

  return resolved;
}

export function resolveCustomTimerStyleVars(mode, theme, viewportWidth, viewportHeight) {
  const preset = resolvePresetCollection(mode, theme);
  if (!preset) return {};

  const layoutProfile = getLayoutViewportProfile(viewportWidth, viewportHeight);

  const resolved = cloneVars(preset.vars);
  const bucketOverrides = resolvePresetBuckets(preset)?.[layoutProfile.key]?.vars || {};
  Object.assign(resolved, bucketOverrides);

  const legacyBreakpoint = resolveLegacyBreakpointKey(preset, layoutProfile);
  if (legacyBreakpoint) {
    const overrides = preset.breakpoints?.[legacyBreakpoint]?.vars || {};
    Object.assign(resolved, overrides);
  }

  return resolved;
}

export function resolveCustomTimerLayoutProfile(viewportWidth, viewportHeight) {
  return getLayoutViewportProfile(viewportWidth, viewportHeight);
}